import React, { useRef, useEffect, useState } from "react";
import "./SimilarItem.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const PremiumFeaturedListings = () => {
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ STATIC PROPERTY DATA (6 Cards)
  const projects = [
    {
      property_name: "Luxury Sky Villa",
      location: "Mumbai, Maharashtra",
      price: "2.5 Cr",
      status: "Available",
      property_image_url:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
      no_of_beds: 4,
      no_of_bathroom: 3,
      plot_size: "3200 sqft",
    },
    {
      property_name: "Modern Lake View Apartment",
      location: "Bangalore, Karnataka",
      price: "1.8 Cr",
      status: "Under Offer",
      property_image_url:
        "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c",
      no_of_beds: 3,
      no_of_bathroom: 2,
      plot_size: "2100 sqft",
    },
    {
      property_name: "Premium Garden Bungalow",
      location: "Delhi NCR",
      price: "3.2 Cr",
      status: "Available",
      property_image_url:
        "https://images.unsplash.com/photo-1600047509358-9dc75507daeb",
      no_of_beds: 5,
      no_of_bathroom: 4,
      plot_size: "4500 sqft",
    },
    {
      property_name: "City Center Penthouse",
      location: "Kolkata, West Bengal",
      price: "2.1 Cr",
      status: "Available",
      property_image_url:
        "https://images.unsplash.com/photo-1600573472591-ee6b68d14c68",
      no_of_beds: 3,
      no_of_bathroom: 3,
      plot_size: "2500 sqft",
    },
    {
      property_name: "Sea Facing Villa",
      location: "Goa",
      price: "4.5 Cr",
      status: "Under Offer",
      property_image_url:
        "https://images.unsplash.com/photo-1480074568708-e7b720bb3f09?q=80&w=1174&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      no_of_beds: 6,
      no_of_bathroom: 5,
      plot_size: "5200 sqft",
    },
    {
      property_name: "Smart Studio Apartment",
      location: "Hyderabad, Telangana",
      price: "85 Lakhs",
      status: "Available",
      property_image_url:
        "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3",
      no_of_beds: 1,
      no_of_bathroom: 1,
      plot_size: "900 sqft",
    },
  ];

  const scroll = (dir) => {
    if (!scrollRef.current) return;

    const cardWidth = scrollRef.current.firstChild?.offsetWidth || 320;
    scrollRef.current.scrollBy({
      left: dir === "left" ? -cardWidth : cardWidth,
      behavior: "smooth",
    });
  };

  const availableProjects = projects.filter(
    (item) =>
      item.status === "Under Offer" || item.status === "Available"
  );

  const showArrows =
    isDesktop && availableProjects.length >= 4;

  return (
<section className="pfl-wrapper">
  <div className="pfl-header">
    <h2 className="pfl-title">Similar Properties</h2>
  </div>

  <div className="pfl-slider-container">
    {showArrows && (
      <button
        className="pfl-arrow pfl-arrow-left"
        onClick={() => scroll("left")}
      >
        &#10094;
      </button>
    )}

    <div className="pfl-track" ref={scrollRef}>
      {availableProjects.map((item, i) => (
        <motion.div
          key={i}
          className="pfl-card"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          whileHover={{ y: -10 }}
        //   onClick={() =>
        //     navigate("/properties/1", {
        //       state: { propertyData: item }
        //     })
        //   }
        >
          <div className="pfl-media">
            <img
              src={item.property_image_url}
              alt={item.property_name}
            />
            <span className="pfl-badge">
              {item.status}
            </span>
          </div>

          <div className="pfl-content">
            <h3 className="pfl-property-name">
              {item.property_name}
            </h3>

            <div className="pfl-location-price">
              <span className="pfl-location">
                {item.location}
              </span>
              <span className="pfl-price">
                ₹ {item.price}
              </span>
            </div>

            <div className="pfl-divider"></div>

            <div className="pfl-features">
              <span>{item.no_of_beds} Beds</span>
              <span>{item.no_of_bathroom} Baths</span>
              <span>{item.plot_size}</span>
            </div>
          </div>
        </motion.div>
      ))}
    </div>

    {showArrows && (
      <button
        className="pfl-arrow pfl-arrow-right"
        onClick={() => scroll("right")}
      >
        &#10095;
      </button>
    )}
  </div>
</section>
  );
};

export default PremiumFeaturedListings;